
          <div class="cust-width">
            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Plate No</th>
                    <th>Vehicle Make</th>
                    <th>Vehicle Model</th>
                    <th>Year</th>
                    <th>Chassis Number</th>
                    <th>Engine Number</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody *ngIf="data?.length > 0">
                  <tr *ngFor="let eachDetail of data; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ eachDetail?.plate_number }}</td>
                    <td>{{ eachDetail?.vehicle_make }}</td>
                    <td>{{ eachDetail?.vehicle_model }}</td>

                    <td>{{ eachDetail?.make_year }}</td>
                    <td>{{ eachDetail?.chassis_number }}</td>
                    <td>{{ eachDetail?.engine_number }}</td>
                    <td [ngClass]="{
                      'not-paid': eachDetail?.vehicle_status === 'NOT_PAID',
                      paid: eachDetail?.vehicle_status === 'PAID'
                    }">
                      {{ eachDetail?.vehicle_status | removeUnderscores }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="p-3">
                <p class="text-center" *ngIf="!data && !(resultsEmpty || error)">Loading... Please Wait...</p>

                <p class="text-center text-danger" *ngIf="resultsEmpty">No data available</p>
                <p class="text-center text-danger" *ngIf="error">Error fetching data</p>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-3">
                <div class="d-flex align-items-center">
                  <label for="pageSize" class="me-2 fw-semibold">Page Size:</label>
                  <select id="pageSize" class="form-select form-select-sm" style="width: auto" [(ngModel)]="pageSize"
                    (change)="onPageSizeChange()">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">
                      {{ size }}
                    </option>
                  </select>
                </div>

                <ngb-pagination class="my-3" [(page)]="currentPage" [pageSize]="pageSize" [collectionSize]="count"
                  [maxSize]="5" [boundaryLinks]="true" [directionLinks]="true" (pageChange)="fetchInfo()">
                </ngb-pagination>
              </div>
            </div>
           
          </div>
